import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useTranscribersPayments, PaymentStatus, TranscriberPayment } from "../../contexts/TranscribersPaymentsContext.tsx";

import PaymentStatusBadge from "./components/PaymentStatusBadge.tsx";

export function PaymentsHistoryItem({ transcriber_payment }: { transcriber_payment: TranscriberPayment }) {
  const navigate = useNavigate();
  const onClick = () => navigate(`/payments/${transcriber_payment.id}`);

  return (
    <Card className="hover:bg-accent/50 transition-colors cursor-pointer" onClick={onClick}>
      <CardContent className="p-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {transcriber_payment?.invoice?.ref?.length > 0 && (
            <span className="font-mono text-sm">#{transcriber_payment.invoice.ref}</span>
          )}
          <PaymentStatusBadge status={transcriber_payment.status} />
        </div>
        <span className="font-medium">
            {transcriber_payment.invoice.total.amount.toFixed(2)} $
        </span>
      </CardContent>
    </Card>
  );
}

export default function PaymentsHistory() {
  const {
    state: { fetchTranscribersPayments: { data }}
  } = useTranscribersPayments();

  return (
    <div className="flex h-full flex-col gap-1 overflow-y-auto">
      {data.map((transcriber_payment) => (
        <PaymentsHistoryItem key={transcriber_payment.id} transcriber_payment={transcriber_payment} />
      ))}
    </div>
  );
}